module.exports = __webpack_public_path__ + "img/1.7cec041a.jpg";